import { DEFAULT_CANDIDATE } from '~/consts/candidates';
import { getStore } from '~/mobx/AppStore';

const resetDetailForm = () => {
    const { candidateStore } = getStore();
    candidateStore.setSelectedCandidateId('');
    candidateStore.setSelectedCandidateMemo();
    candidateStore.setSelectedCandidateEdit(DEFAULT_CANDIDATE);
};

export default resetDetailForm;
